import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Layout from "components/sales/layout/layout";
import localization from "assets/localization/localization";
import Notfound from "pages/notfound";
import AddToCart from "components/brandActivation/addToCart";
import "./style.css";

const ProductDetails = ({
  viewProdDetails = null,
  getProductDetails,
  match
}) => {
  const [details, setDetails] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isRender, setIsRender] = useState(false);
  const [lgImgIndex, setLgImgIndex] = useState(0);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const res = await getProductDetails(match.params.id);
      setIsLoading(false);
      if (res === false) {
        setIsRender(true);
      }
      else setIsRender(false);
    })();
  }, [getProductDetails]);

  useEffect(() => {
    if (viewProdDetails !== null && viewProdDetails) {
      setDetails(viewProdDetails);
    }
    else setIsRender(false);
  }, [viewProdDetails]);

  return isRender ? (
    <Notfound />
  ) : (
    <Layout title={localization.BacktoList} isGoback isLoading={isLoading}>
        <div className="product-wrapper">
        {details !== null ?
          <div className="details-wrapper">
            <div className="images-wrapper equal-width">
              <figure>
                  <img className="img-responsive" src={details.img[lgImgIndex].images} alt={details.name} /> 
              </figure>
              <div className="other-images">
                {details?.img?.length > 0 && details?.img.map((img, index) => 
                  <figure key={index} onClick={()=> setLgImgIndex(index)} className={lgImgIndex === index ?"active" : ""}>
                    <img className="img-responsive" src={img.images} alt={index} /> 
                  </figure>
                )}
              </div>
            </div>
            <div className="desc-wrapper equal-width">
              <div className="title">{details.name}</div>
              <div className="description">{details.description}</div>
              <div className="prices">
                  <span>{`₹${details.price}`}</span>
                  <span><del>{`₹${details.selling_price}`}</del></span>
              </div>
              <br />
              <AddToCart product={details}/>
            </div>
          </div>
          : <div>No Products</div>
        }
    </div>
    </Layout>
  );
};

ProductDetails.propTypes = {
  viewProducts: PropTypes.object,
  getProductDetails: PropTypes.func,
  match: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
};

export default ProductDetails;
